<form class="example-form">
    <mat-form-field class="full-width">

        <mat-chip-list #chipList aria-label="Site selection">
            <mat-chip
                        *ngFor="let site of sites"
                        removable="true"
                        (removed)="remove(site)">
                {{site.name}}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input
                    #siteInput
                    [placeholder]       =   "'autocomplete.name.site' | translate"
                    [formControl]       =   "siteCtrl"
                    [matAutocomplete]   =   "auto"
                    [matChipInputFor]   =   "chipList"
                    (focus)             =   "focused($event)"
                    (click)             =   "siteTrigger.openPanel()"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
        </mat-chip-list>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
            <mat-option *ngFor="let site of filteredSites | async" [value]="site">
                {{site.name}}
            </mat-option>
        </mat-autocomplete>
        
    </mat-form-field>
</form>